import { useQuery } from 'react-query';
import * as api from '../../services/api';

export const HELP_DESK_TICKET_QUERY_KEY = 'helpDeskTicket';

export const getHelpDeskTicketQueryKey = (accountId, ticketId) => [
  HELP_DESK_TICKET_QUERY_KEY,
  accountId ?? null,
  ticketId !== undefined ? Number(ticketId) : null
];

/**
 * Fetch a single help desk ticket by ID.
 * @param {Object} params
 * @param {string|number} params.accountId
 * @param {string|number} params.ticketId
 * @param {boolean} [params.enabled=true]
 */
const useHelpDeskTicket = ({ accountId, ticketId, enabled = true }) => {
  const queryKey = getHelpDeskTicketQueryKey(accountId, ticketId);

  const { data, isLoading, isError: queryError } = useQuery(
    queryKey,
    () => api.fetchHelpDeskTicket({ accountId, ticketId }),
    {
      enabled: !!accountId && !!ticketId && enabled,
      retry: false
    }
  );

  const ticket = data?.data;
  const isError = !isLoading && (!ticket || queryError);

  return { ticket, isLoading, isError };
};

export default useHelpDeskTicket;
